export interface BaseEntityDto{
  createdAt?:Date;
  updatedAt?:Date;
}
